import { useContext, useEffect, useState } from "react";
import IdeaContext from "../IdeaContext";
import { Box, Button, Checkbox, Flex, Skeleton, Stack, Text, Tooltip } from "@mantine/core";
import EvidenceCardNiv from "./EvidenceCardNiv";
import { IconCaretDown, IconCaretUp } from "@tabler/icons";
import { Loader, ZeroState } from "../../../icons/x-symbol-svgrepo-com";

const InitialEvidenceScreen = ({
  chooseMatch,
  chosenEvidence,
  selectedEvidenceIds,
  setSelectedEvidenceIds,
}: {
  chooseMatch: any;
  chosenEvidence: any;
  selectedEvidenceIds: any;
  setSelectedEvidenceIds: any;
}) => {
  const {
    displayedMatches,
    loadingEvidence,
    displayedRequests,
    matchesLoading,
    showmatches,
    showValidated,
    computed,
    ideaId,
    matchesTimer,
    getMatchesUpdate,
    matchesTrigger,
    displayedRequestsMatches,
    showPending,
    idea,
    activeSort
  } = useContext(IdeaContext);
 
  const [inboxItems, setInboxItems] = useState<any[]>([])
  const [matchesLengthToDisplay, setMatchesLengthToDisplay] = useState(4);
  const computedValue = computed || "done";
  const bannerShow : boolean = (idea?.validationObject?.verifyState == 'completed' || idea?.maturity?.maturityLevel == 5 ) == true ? false : true

  const requests = displayedRequests.filter(
    (r: any) => r.ideaId === ideaId
  );
  
  useEffect(() => {
    matchesTimer();
    getMatchesUpdate();
  }, [matchesTrigger, ideaId]);

  useEffect(() => {
    if (!showValidated) {
      setMatchesLengthToDisplay(100);
    } else {
      setMatchesLengthToDisplay(4);
    }
  }, [showValidated]);

  useEffect(() => {

    const _pendingRequests = displayedRequests.filter(
      (r: any) => r.state === "inReview" && r.gtmIdeaId === ideaId
    );
   
    const inbox = [..._pendingRequests, ...displayedRequestsMatches]
    setInboxItems(inbox)

  }, [displayedRequests, displayedRequestsMatches]);

  const toggleSelectAll = (items: any[], checked: boolean) => {
    if (checked) {
      setSelectedEvidenceIds(items);
    } else {
      setSelectedEvidenceIds([]);
    }
  };

  const isAllSelected = (items: any[]) =>
    items.length > 0 && items.every((item) => selectedEvidenceIds.some((selectedEvidence: any)=>selectedEvidence._id === item._id));

  const allEvidenceSelected = showmatches && showValidated ;

  return (
    <Box>
      {!loadingEvidence &&
      !matchesLoading &&
      requests?.length === 0 &&
      displayedMatches?.length === 0 &&
      computed === "done" 
      && inboxItems?.length === 0
        ? 
        (
          <Flex justify="center" pt="16px" px="20px" w="100%" mt="46px">
            <ZeroState />
          </Flex>
        ) : !loadingEvidence &&
        !matchesLoading &&
        requests?.length === 0 &&
        displayedMatches?.length === 0 &&
        computed !== "done" ? (
            <Stack /* justify="center" */ pt="16px" align="center" mt="46px">
              {matchesTrigger === 0 ? (
                <Loader height={74} width={74} />
              ) : (
                <ZeroState />
              )}
              <Box
                bg="rgba(92, 92, 235, 0.1)"
                p="md"
                /* align="center" */ w={500}
                mt="38px"
                sx={{ borderRadius: "8px" }}
              >
                <span style={{ fontWeight: 600, marginRight: "5px" }}>
              There are currently no matching evidence,
                </span>
            Bagel will keep scanning all sources and will update as soon as a
            new match is found
              </Box>
            </Stack>
          ) : (
            <>
              { allEvidenceSelected && selectedEvidenceIds.length > 0 && <Checkbox
                size="xs"
                checked={isAllSelected([...displayedMatches, ...requests, ...inboxItems])}
                onChange={(e) =>
                  toggleSelectAll([...displayedMatches, ...requests, ...inboxItems], e.currentTarget.checked)
                }
                label="Select All"
                sx={{
                  input: {
                    width: "16px",
                    height: "16px",
                    border: "2px solid #5C5CEB", 
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "&:checked": {
                      backgroundColor: "#5C5CEB", 
                      borderColor: "#5C5CEB",
                    },
                  },
                }}
                style={{
                  marginLeft: "25px",
                  marginBottom: "9px",
                  fontSize: "13px",
                  marginTop: "5px"
                }}
              >
              </Checkbox>}
              {showmatches && (
                <>
                  {(matchesLoading || displayedMatches?.length > 0) && (
                    <Box px="20px" w="100%" mb={ bannerShow && displayedMatches?.length > 4  ? "5.25rem" : "lg"} mt="6px">
                      <Text color="dimmed" mb="sm">
                    Suggested Evidence
                      </Text>
                      {!allEvidenceSelected && selectedEvidenceIds.length > 0 && displayedMatches.length > 0 && <Checkbox
                        size="xs"
                        checked={isAllSelected(displayedMatches)}
                        onChange={(e) =>
                          toggleSelectAll(displayedMatches, e.currentTarget.checked)
                        }
                        label="Select All"
                        sx={{
                          input: {
                            width: "16px",
                            height: "16px",
                            border: "2px solid #5C5CEB", 
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            "&:checked": {
                              backgroundColor: "#5C5CEB", 
                              borderColor: "#5C5CEB",
                            },
                          },
                        }}
                        style={{
                          marginLeft: "7px",
                          marginBottom: "20px",
                          fontSize: "13px"
                        }}
                      >
                      </Checkbox>}
                      {displayedMatches?.length > 0 &&
                    displayedMatches
                      ?.slice(0, matchesLengthToDisplay)
                      ?.map((evidence: any, index: number) => {
                        // Check if this is the first weak match and we need to show the text
                        const isFirstWeakMatch = evidence?.match?.level !== 'Strong' && 
                          displayedMatches?.slice(0, index).every((prev: any) => prev?.match?.level === 'Strong');
                        
                        return (
                          <Box key={evidence._id}>
                            {!activeSort && isFirstWeakMatch && (
                              <Text color="dimmed" mb="sm" my={12} fz={13}>
                                Evidence with weaker match signal
                              </Text>
                            )}
                            <EvidenceCardNiv
                              item={evidence}
                              chooseMatch={chooseMatch}
                              index={index}
                              fromSearch={false}
                              chosenEvidence={chosenEvidence}
                              ideaPage
                              selectedEvidenceIds={selectedEvidenceIds}
                              setSelectedEvidenceIds={setSelectedEvidenceIds}
                            />
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                  {matchesLoading &&
                displayedMatches.length == 0 &&
                computedValue === "done" && (
                    <Box w="99%" pr="20px" pl="8px" mt={8} mb={!bannerShow ? "md" : "" }>
                      {[1, 2].map((i) => (
                        <Skeleton
                          key={i}
                          m="sm"
                          height={66}
                          mb={0}
                          sx={{ borderRadius: "8px" }}
                        />
                      ))}
                    </Box>
                  )}
                </>
              )}
              {showmatches && displayedMatches?.length > 4 && showValidated && (
                <Flex justify="center" mt={bannerShow ? "-4rem" : "1rem"} mb={ bannerShow ? "1.25rem" : "0rem"}>
                  <Button
                    variant="default"
                    onClick={() => {
                      if (matchesLengthToDisplay === 4) {
                        setMatchesLengthToDisplay(displayedMatches?.length);
                      } else {
                        setMatchesLengthToDisplay(4);
                      }
                    }}
                  >
                    <Text color="#5C5CEB" fz={13} fw={400}>
                      {matchesLengthToDisplay === 4 ? "Show all" : "Show less"}
                    </Text>

                    {matchesLengthToDisplay === 4 ? (
                      <IconCaretDown color="#5C5CEB" />
                    ) : (
                      <IconCaretUp color="#5C5CEB" />
                    )}
                  </Button>
                </Flex>
              )}
              {showValidated && (
                <Box w="100%" px="20px" mt={ 6} mb={bannerShow && requests?.length > 0 ? "4.25rem" : "0rem"}>
                  {(loadingEvidence || (requests && requests?.length > 0)) && (
                    <Text color="dimmed" mb="13px">
                      Assigned Evidence
                    </Text>
                  )}
                  { !allEvidenceSelected && selectedEvidenceIds.length > 0 && requests.length > 0 && <Checkbox
                    size="xs"
                    color="#5C5CEB"
                    checked={isAllSelected(requests)}
                    onChange={(e) => toggleSelectAll(requests, e.currentTarget.checked)}
                    label="Select All"
                    sx={{
                      input: {
                        width: "16px",
                        height: "16px",
                        border: "2px solid #5C5CEB", 
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "13px",
                        "&:checked": {
                          backgroundColor: "#5C5CEB", 
                          borderColor: "#5C5CEB",
                        },
                      },
                    }}
                    style={{
                      marginLeft: "7px",
                      marginBottom: "20px",
                      fontSize: "13px"
                    }}
                  >
                  </Checkbox>}
                  {requests &&
                requests?.length > 0 &&
                requests?.map((request: any, index: number) => (
                  <EvidenceCardNiv
                    key={index}
                    item={request}
                    chooseMatch={chooseMatch}
                    index={index}
                    fromSearch={false}
                    chosenEvidence={chosenEvidence}
                    ideaPage
                    selectedEvidenceIds={selectedEvidenceIds}
                    setSelectedEvidenceIds={setSelectedEvidenceIds}
                  />
                ))}
                </Box>
              )}
              {loadingEvidence &&
            requests?.length === 0 &&
            displayedMatches?.length === 0 && (
                <Box w="99%" pr="20px" pl="8px" mt={8}>
                  {[1, 2, 3, 4].map((i) => (
                    <Skeleton
                      key={i}
                      m="sm"
                      height={66}
                      mb={0}
                      sx={{ borderRadius: "8px" }}
                    />
                  ))}
                </Box>
              )}
            </>
          )}
      <Box>
        {showValidated && showmatches && inboxItems && inboxItems?.length > 0 &&
          <Box px="20px" w="100%" mb={ bannerShow ? "5.25rem" : "lg"} mt={(requests?.length + displayedMatches?.length) > 0 ? 16: 6}>
            <Box w={100}>
              <Tooltip label='Formal requests'>
                <Text color="dimmed" mb="sm">
              Inbox
                </Text>
              </Tooltip>
              { !allEvidenceSelected && selectedEvidenceIds.length > 0 && inboxItems.length> 0 && <Checkbox
                size="xs"
                color="#5C5CEB"
                checked={isAllSelected(inboxItems)}
                onChange={(e) => toggleSelectAll(inboxItems, e.currentTarget.checked)}
                label="Select All"
                sx={{
                  input: {
                    width: "16px",
                    height: "16px",
                    border: "2px solid #5C5CEB", 
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "&:checked": {
                      backgroundColor: "#5C5CEB", 
                      borderColor: "#5C5CEB",
                    },
                  },
                }}
                style={{
                  marginLeft: "7px",
                  marginBottom: "20px",
                  fontSize: "13px"
                }}
              >
              </Checkbox>}
            </Box>
            {inboxItems?.length > 0 &&
              inboxItems?.map((evidence: any, index: number) => (
                <EvidenceCardNiv
                  key={evidence._id}
                  item={evidence}
                  chooseMatch={chooseMatch}
                  index={index}
                  fromSearch={false}
                  chosenEvidence={chosenEvidence}
                  ideaPage
                  selectedEvidenceIds={selectedEvidenceIds}
                  setSelectedEvidenceIds={setSelectedEvidenceIds}
                />
              ))}
          </Box>
        }
      </Box>
    </Box>
  );
};

export default InitialEvidenceScreen;
